import { Link } from '@tanstack/react-router'
import { Code2, Smartphone, Settings2, Layers, ArrowRight } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/Card'
import { services } from '@/constants/services'

const iconMap: Record<string, LucideIcon> = {
  Code2,
  Smartphone,
  Settings2,
  Layers,
}

export function ServicesOverviewSection() {
  // Showcase the first 4 primary services on homepage
  const featuredServices = services.slice(0, 4)

  return (
    <Section surface="0" withBorder>
      <Container>
        {/* Section Heading */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 sm:mb-12 gap-4 sm:gap-6">
          <div className="max-w-xl">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-fg">
              Core Capabilities
            </h2>
            <p className="mt-2.5 sm:mt-3 text-sm sm:text-base text-fg-subtle">
              Engineered for longevity, scalability, and performance. We build software that empowers your operations.
            </p>
          </div>
          <Link
            to="/services"
            className="inline-flex items-center gap-1.5 py-1.5 text-sm font-semibold text-fg hover:text-fg-subtle active:opacity-75 transition-colors self-start md:self-auto"
          >
            <span>View All Services</span>
            <ArrowRight size={16} />
          </Link>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {featuredServices.map((service) => {
            const Icon = iconMap[service.iconName] || Code2

            return (
              <Card key={service.id} surface="2" hoverable className="p-6 sm:p-8">
                <div className="mb-5 flex h-10 w-10 items-center justify-center rounded-sm bg-surface-3 text-fg">
                  <Icon size={20} />
                </div>
                <CardHeader>
                  <CardTitle className="text-lg sm:text-xl">{service.title}</CardTitle>
                  <CardDescription className="mt-2 text-sm sm:text-base">
                    {service.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            )
          })}
        </div>
      </Container>
    </Section>
  )
}
